import { render } from "./guide-page.vue?vue&type=template&id=36893142"
import script from "./guide-page.vue?vue&type=script&lang=js"
export * from "./guide-page.vue?vue&type=script&lang=js"

import "../assets/style/styles.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__